import { ReactElement } from 'react';
// Next
import dynamic from 'next/dynamic';
// Interfaces
import { IconsEnum, IconsProps } from '@utmb/types/icons';

const icons = {
    [IconsEnum.ADVICE]: dynamic(() => import('./svgs/Advice')),
    [IconsEnum.ARRIVAL]: dynamic(() => import('./svgs/Arrival')),
    [IconsEnum.ARTICLE]: dynamic(() => import('./svgs/Article')),
    [IconsEnum.ATTACHEMENT]: dynamic(() => import('./svgs/Attachement')),
    [IconsEnum.ARROW]: dynamic(() => import('./svgs/Arrow')),
    [IconsEnum.ATHLETES_SERVICES]: dynamic(() => import('./svgs/AthletesServices')),
    [IconsEnum.BAGS_LIGHTENING]: dynamic(() => import('./svgs/BagsLightening')),
    [IconsEnum.BAN]: dynamic(() => import('./svgs/Ban')),
    [IconsEnum.BEACH]: dynamic(() => import('./svgs/BeachIcon')),
    [IconsEnum.BIB]: dynamic(() => import('./svgs/Bib')),
    [IconsEnum.BIB_COLLECTION]: dynamic(() => import('./svgs/BibCollection')),
    [IconsEnum.BOOKMARK_CHECKED]: dynamic(() => import('./svgs/BookmarkChecked')),
    [IconsEnum.BRIEFING]: dynamic(() => import('./svgs/Briefing')),
    [IconsEnum.BURGER]: dynamic(() => import('./svgs/Burger')),
    [IconsEnum.BUS]: dynamic(() => import('./svgs/Bus')),
    [IconsEnum.CALENDAR]: dynamic(() => import('./svgs/Calendar')),
    [IconsEnum.CAMERA]: dynamic(() => import('./svgs/Camera')),
    [IconsEnum.CAR]: dynamic(() => import('./svgs/Car')),
    [IconsEnum.CHAIN]: dynamic(() => import('./svgs/Chain')),
    [IconsEnum.CHARITY_BIB]: dynamic(() => import('./svgs/CharityBib')),
    [IconsEnum.CHECKBOX]: dynamic(() => import('./svgs/Checkbox')),
    [IconsEnum.CHECKPOINT]: dynamic(() => import('./svgs/Checkpoint')),
    [IconsEnum.CHEVRON_DOWN]: dynamic(() => import('./svgs/ChevronDown')),
    [IconsEnum.CHEVRON_LEFT]: dynamic(() => import('./svgs/ChevronLeft')),
    [IconsEnum.CHEVRON_RIGHT]: dynamic(() => import('./svgs/ChevronRight')),
    [IconsEnum.CHEVRON_UNCONSTRAINED]: dynamic(() => import('./svgs/ChevronUnconstrained')),
    [IconsEnum.CHEVRON_UP]: dynamic(() => import('./svgs/ChevronUp')),
    [IconsEnum.CHEVRON]: dynamic(() => import('./svgs/Chevron')),
    [IconsEnum.CLOSE]: dynamic(() => import('./svgs/Close')),
    [IconsEnum.CLIPBOARD]: dynamic(() => import('./svgs/Clipboard')),
    [IconsEnum.COASTAL_PATH]: dynamic(() => import('./svgs/CoastalPathIcon')),
    [IconsEnum.DAY_TIME]: dynamic(() => import('./svgs/DayTime')),
    [IconsEnum.DESERT]: dynamic(() => import('./svgs/DesertIcon')),
    [IconsEnum.DISCOVER]: dynamic(() => import('./svgs/Discover')),
    [IconsEnum.DONATION]: dynamic(() => import('./svgs/Donation')),
    [IconsEnum.DOWN]: dynamic(() => import('./svgs/Down')),
    [IconsEnum.DOWNLOAD]: dynamic(() => import('./svgs/Download')),
    [IconsEnum.EVENT_CENTER]: dynamic(() => import('./svgs/EventCenter')),
    [IconsEnum.EVENT_VILLAGE]: dynamic(() => import('./svgs/EventVillage')),
    [IconsEnum.EVENTS]: dynamic(() => import('./svgs/Events')),
    [IconsEnum.EXCITED]: dynamic(() => import('./svgs/Excited')),
    [IconsEnum.EYE]: dynamic(() => import('./svgs/Eye')),
    [IconsEnum.EYE_OFF]: dynamic(() => import('./svgs/EyeOff')),
    [IconsEnum.EXCEL]: dynamic(() => import('./svgs/Excel')),
    [IconsEnum.FINISH_INDEX]: dynamic(() => import('./svgs/FinishIndex')),
    [IconsEnum.FINISHERS]: dynamic(() => import('./svgs/Finishers')),
    [IconsEnum.FINISH_WS]: dynamic(() => import('./svgs/FinishWs')),
    [IconsEnum.FLAG]: dynamic(() => import('./svgs/Pen')),
    [IconsEnum.FROZEN_INDEX]: dynamic(() => import('./svgs/FrozenIndex')),
    [IconsEnum.LINEPLUS]: dynamic(() => import('./svgs/LinePlus')),
    [IconsEnum.FOURPLUS]: dynamic(() => import('./svgs/FourPlus')),
    [IconsEnum.NINEPLUS]: dynamic(() => import('./svgs/NinePlus')),
    [IconsEnum.GAME]: dynamic(() => import('./svgs/Game')),
    [IconsEnum.GLACIER]: dynamic(() => import('./svgs/GlacierIcon')),
    [IconsEnum.GLOBE]: dynamic(() => import('./svgs/Globe')),
    [IconsEnum.HAND_COINS]: dynamic(() => import('./svgs/HandCoins')),
    [IconsEnum.HEART]: dynamic(() => import('./svgs/Heart')),
    [IconsEnum.HELP]: dynamic(() => import('./svgs/Help')),
    [IconsEnum.HIGH_ALTITUDE]: dynamic(() => import('./svgs/HighAltitudeIcon')),
    [IconsEnum.HIKING_TRAIL]: dynamic(() => import('./svgs/HikingTrailIcon')),
    [IconsEnum.HILL]: dynamic(() => import('./svgs/HillIcon')),
    [IconsEnum.HOME]: dynamic(() => import('./svgs/Home')),
    [IconsEnum.HOURGLASS]: dynamic(() => import('./svgs/Hourglass')),
    [IconsEnum.INFO]: dynamic(() => import('./svgs/Info')),
    [IconsEnum.INFO_POINT]: dynamic(() => import('./svgs/InfoPoint')),
    [IconsEnum.INTERVIEW]: dynamic(() => import('./svgs/Interview')),
    [IconsEnum.INVOLVED]: dynamic(() => import('./svgs/Involved')),
    [IconsEnum.JUNGLE]: dynamic(() => import('./svgs/JungleIcon')),
    [IconsEnum.LEFT]: dynamic(() => import('./svgs/Left')),
    [IconsEnum.LEGEND]: dynamic(() => import('./svgs/Legend')),
    [IconsEnum.LIVE]: dynamic(() => import('./svgs/Live')),
    [IconsEnum.LOCK]: dynamic(() => import('./svgs/Lock')),
    [IconsEnum.LOGO_AD_BG]: dynamic(() => import('./svgs/LogoAdBg')),
    [IconsEnum.LOGO_SIMPLIFIED_DARK]: dynamic(() => import('./svgs/LogoSimplifiedDark')),
    [IconsEnum.LOGO_SIMPLIFIED]: dynamic(() => import('./svgs/LogoSimplified')),
    [IconsEnum.LOGO_FINALS]: dynamic(() => import('./svgs/LogoFinals')),
    [IconsEnum.LOGO_MAJOR]: dynamic(() => import('./svgs/LogoMajor')),
    [IconsEnum.LOGOUT]: dynamic(() => import('./svgs/Logout')),
    [IconsEnum.MAG]: dynamic(() => import('./svgs/Mag')),
    [IconsEnum.MANDATORY_EQUIPMENT_CHECK]: dynamic(() => import('./svgs/MandatoryEquipmentCheck')),
    [IconsEnum.MEDIA]: dynamic(() => import('./svgs/Media')),
    [IconsEnum.MEDIA_CENTER]: dynamic(() => import('./svgs/MediaCenter')),
    [IconsEnum.MOBILITY]: dynamic(() => import('./svgs/Mobility')),
    [IconsEnum.MOUNTAIN]: dynamic(() => import('./svgs/MountainIcon')),
    [IconsEnum.MY_ACHIEVEMENT]: dynamic(() => import('./svgs/MyAchievement')),
    [IconsEnum.MY_DASHBOARD]: dynamic(() => import('./svgs/MyDashboard')),
    [IconsEnum.MY_INFORMATION]: dynamic(() => import('./svgs/MyInformation')),
    [IconsEnum.MY_REGISTRATION]: dynamic(() => import('./svgs/MyRegistration')),
    [IconsEnum.MY_REWARDS]: dynamic(() => import('./svgs/MyRewards')),
    [IconsEnum.MY_UTMB_POINTS]: dynamic(() => import('./svgs/MyUtmbPoints')),
    [IconsEnum.MY_UTMB_POINTS_GENERIC]: dynamic(() => import('./svgs/MyUtmbPointsGeneric')),
    [IconsEnum.NEXT]: dynamic(() => import('./svgs/Next')),
    [IconsEnum.NIGHT_TIME]: dynamic(() => import('./svgs/NightTimeIcon')),
    [IconsEnum.NO]: dynamic(() => import('./svgs/No')),
    [IconsEnum.OTHER]: dynamic(() => import('./svgs/Other')),
    [IconsEnum.PARKING]: dynamic(() => import('./svgs/Parking')),
    [IconsEnum.PEN]: dynamic(() => import('./svgs/Pen')),
    [IconsEnum.PHOTOS]: dynamic(() => import('./svgs/Photos')),
    [IconsEnum.PIN]: dynamic(() => import('./svgs/Pin')),
    [IconsEnum.PLANE]: dynamic(() => import('./svgs/Plane')),
    [IconsEnum.PLUS_LOYALTY]: dynamic(() => import('./svgs/PlusLoyalty')),
    [IconsEnum.QUOTE]: dynamic(() => import('./svgs/Quote')),
    [IconsEnum.RACE_FLAG]: dynamic(() => import('./svgs/RaceFlag')),
    [IconsEnum.RACE]: dynamic(() => import('./svgs/Race')),
    [IconsEnum.RANDOM]: dynamic(() => import('./svgs/Random')),
    [IconsEnum.REFUELING_STAND]: dynamic(() => import('./svgs/RefuelingStand')),
    [IconsEnum.RIGHT]: dynamic(() => import('./svgs/Right')),
    [IconsEnum.ROAD]: dynamic(() => import('./svgs/RoadIcon')),
    [IconsEnum.RS]: dynamic(() => import('./svgs/Rs')),
    [IconsEnum.RULER]: dynamic(() => import('./svgs/Ruler')),
    [IconsEnum.RUNNER]: dynamic(() => import('./svgs/UtmbRunner')),
    [IconsEnum.RUNNER_BAG]: dynamic(() => import('./svgs/RunnerBag')),
    [IconsEnum.RUNNING_STONE]: dynamic(() => import('./svgs/RunningStone')),
    [IconsEnum.RUNNING_STONES]: dynamic(() => import('./svgs/RunningStones')),
    [IconsEnum.SEARCH]: dynamic(() => import('./svgs/Search')),
    [IconsEnum.SHARE]: dynamic(() => import('./svgs/Share')),
    [IconsEnum.SHOP]: dynamic(() => import('./svgs/Shop')),
    [IconsEnum.SINGLE_TRACK]: dynamic(() => import('./svgs/SingleTrackIcon')),
    [IconsEnum.SMILEY_LAUGH]: dynamic(() => import('./svgs/SmileyLaugh')),
    [IconsEnum.SMILEY_SHY]: dynamic(() => import('./svgs/SmileyShy')),
    [IconsEnum.SMILEY_SURPRISED]: dynamic(() => import('./svgs/SmileySurprised')),
    [IconsEnum.SOCIAL_DAILYMOTION]: dynamic(() => import('./svgs/DailyMotion')),
    [IconsEnum.SOCIAL_FACEBOOK]: dynamic(() => import('./svgs/Facebook')),
    [IconsEnum.SOCIAL_INSTAGRAM]: dynamic(() => import('./svgs/Instagram')),
    [IconsEnum.SOCIAL_LINKEDIN]: dynamic(() => import('./svgs/LinkedIn')),
    [IconsEnum.SOCIAL_STRAVA]: dynamic(() => import('./svgs/Strava')),
    [IconsEnum.SOCIAL_TIKTOK]: dynamic(() => import('./svgs/TikTok')),
    [IconsEnum.SOCIAL_TWITTER]: dynamic(() => import('./svgs/Twitter')),
    [IconsEnum.SOCIAL_WECHAT]: dynamic(() => import('./svgs/WeChat')),
    [IconsEnum.SOCIAL_X]: dynamic(() => import('./svgs/SocialX')),
    [IconsEnum.SOCIAL_YOUTUBE]: dynamic(() => import('./svgs/Youtube')),
    [IconsEnum.SPECTATORS]: dynamic(() => import('./svgs/Spectators')),
    [IconsEnum.SPINNER]: dynamic(() => import('./svgs/Spinner')),
    [IconsEnum.STAR_BORDER]: dynamic(() => import('./svgs/StarBorder')),
    [IconsEnum.START]: dynamic(() => import('./svgs/Start')),
    [IconsEnum.START_INDEX]: dynamic(() => import('./svgs/StartIndex')),
    [IconsEnum.START_WS]: dynamic(() => import('./svgs/StartWs')),
    [IconsEnum.STAR]: dynamic(() => import('./svgs/Star')),
    [IconsEnum.STONE_EVENTS]: dynamic(() => import('./svgs/StoneEvents')),
    [IconsEnum.STONE_MAJORS]: dynamic(() => import('./svgs/StoneMajors')),
    [IconsEnum.SUPPORTERS]: dynamic(() => import('./svgs/Supporters')),
    [IconsEnum.SWORDS]: dynamic(() => import('./svgs/Swords')),
    [IconsEnum.TERRAIN]: dynamic(() => import('./svgs/Terrain')),
    [IconsEnum.THUMB_UP]: dynamic(() => import('./svgs/ThumbUp')),
    [IconsEnum.TICKET]: dynamic(() => import('./svgs/Ticket')),
    [IconsEnum.TOP1]: dynamic(() => import('./svgs/Top1')),
    [IconsEnum.TOP2]: dynamic(() => import('./svgs/Top2')),
    [IconsEnum.TOP3]: dynamic(() => import('./svgs/Top3')),
    [IconsEnum.TOURISM]: dynamic(() => import('./svgs/Tourism')),
    [IconsEnum.TRAIL_RUNNERS]: dynamic(() => import('./svgs/TrailRunners')),
    [IconsEnum.TRAIN]: dynamic(() => import('./svgs/Train')),
    [IconsEnum.TRASH]: dynamic(() => import('./svgs/Trash')),
    [IconsEnum.TRASH_SECOND]: dynamic(() => import('./svgs/TrashSecond')),
    [IconsEnum.TUNNEL]: dynamic(() => import('./svgs/Tunnel')),
    [IconsEnum.UP]: dynamic(() => import('./svgs/Up')),
    [IconsEnum.USER]: dynamic(() => import('./svgs/User')),
    [IconsEnum.UTMB_FINAL]: dynamic(() => import('./svgs/UtmbFinal')),
    [IconsEnum.UTMB_GROUP]: dynamic(() => import('./svgs/UtmbGroup')),
    [IconsEnum.UTMB_RUNNER]: dynamic(() => import('./svgs/UtmbRunner')),
    [IconsEnum.VOLONTEER]: dynamic(() => import('./svgs/Volonteer')),
    [IconsEnum.VOLUNTEERS]: dynamic(() => import('./svgs/Volunteers')),
    [IconsEnum.WOODS]: dynamic(() => import('./svgs/WoodIcon')),
    [IconsEnum.WS_CATEGORIES]: dynamic(() => import('./svgs/WsCategories')),
};

export const Icon = (props: IconsProps): ReactElement => {
    const { color = 'currentColor', variant, clss, width, height, hideText } = props;
    if (typeof icons[variant] !== 'undefined') {
        const Icon = icons[variant];
        return <Icon color={color} clss={clss} width={width} height={height} hideText={hideText} />;
    }
    return <></>;
};
